import React, { useCallback, useEffect, useState } from "react";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import { t } from "i18next";
import SupervisorSignCheck from "../../../Hospital/components/SupervisorSignCheck/SupervisorSignCheck";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
  Checkbox,
  ChoiceGroup,
  ComboBox,
  Dropdown,
  SelectableOptionMenuItemType,
  TextField,
} from "@fluentui/react";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import { values } from "underscore";
import {
  getModalityList,
  getSubModalityListNumbers,
} from "../../../../service/FirmServices";
import Select from "react-select";
import { PrimaryButton } from "@fluentui/react";
import "../../firm.css";

const HospitalSettings = (props) => {
  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;
  const [enablePrintDisclaimerText, setEnablePrintDisclaimerText] = useState(
    props.values.addPrintDisclaimer
  );
  const [enableAddendumDisclaimerText, setEnableAddendumDisclaimerText] =
    useState(props.values.addendumDisclaimerEnabled);
  const [addSupervisorSignature, setAddSupervisorSignature] = useState(
    props.values.addSupervisorSignature
  );
  const [qcEnabled, setQcEnabled] = useState(props.values.qcEnabled);
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(
    props.values.autoAssignEnable
  );
  const [selectedModality, setSelectedModality] = useState(
    props.values.modalityIds
  );
  const [selectedAutoAssignModality, setSelectedAutoAssignModality] = useState(
    props.values.autoAssignModalityIds
  );
  const [enableShareReportLink, setEnableShareReportLink] = useState(
    props.values.enableShareReportLink
  );
  const [enableUnassignmentService, setEnableUnassignmentService] = useState(props.values.enableUnassignmentService);

  // const [showWord, setShowWord] = useState(props.values.showWord);

  const [modalityList, setModalityList] = useState([]);
  const [supervisor2Signtaure, setSupervisor2Signature] = useState(
    props.values.signature2Dto.signatureFile2?.name
  );
  const [supervisor3Signtaure, setSupervisor3Signature] = useState(
    props.values.signature3Dto.signatureFile3?.name
  );
  const [subModalityListNumbers, setSubModalityListNumbers] = useState([]);

  const [signature2Image, setSignature2Image] = useState(
    props.signature2ImageValue ? true : false
  );
  const [signature3Image, setSignature3Image] = useState(
    props.signature3ImageValue ? true : false
  );

  useEffect(() => {
    if (props.roles[0] === USERTYPES.FIRMADMIN) {
      fetchSubModalityListNumbers();
    }
  }, [props.roles]);

  const fetchSubModalityListNumbers = async () => {
    const response = await getSubModalityListNumbers();
    console.log(response);
    if (response.status === 200) {
      let mdl = [];
      response.data.data.map((listnum) => {
        mdl.push({
          key: listnum,
          text: listnum,
        });
      });
      setSubModalityListNumbers(mdl);
    }
  };

  useEffect(() => {
    console.log(subModalityListNumbers);
  }, [subModalityListNumbers]);

  const fetchModalityList = async () => {
    const response = await getModalityList();
    if (response.status === 200) {
      // setModalityList([{ key: 0, modality: "Select all" }]);
      // let mdl = [{ key: "selectAll", text: "Select all" }];
      let mdl = [];
      response.data.data.map((modality) => {
        mdl.push({
          key: modality.id,
          text: modality.name,
        });
      });
      setModalityList(mdl);
    }
  };

  useEffect(() => {
    if (modalityList.length === 0) fetchModalityList();
  }, [autoAssignEnabled]);

  useEffect(() => {
    props.values.autoAssignModalityIds = selectedAutoAssignModality;
  }, [selectedAutoAssignModality]);

  useEffect(() => {
    props.values.modalityIds = selectedModality;
  }, [selectedModality]);

  const choiceGroupStyles = {
    label: {
      display: "inline",
    },
    flexContainer: {
      columnGap: "1em",
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
  };

  useEffect(() => {}, [enablePrintDisclaimerText]);

  useEffect(() => {
    if (!addSupervisorSignature) {
      props.handleClearImage("signature3");
      setSignature3Image(false);
      props.values.signature2Dto.signatureFile3 = null;
      props.setIsSignatureFile3Deleted(true);
      props.values.signature3Dto.isSignatureImageDeleted = 1;
    }
  }, [addSupervisorSignature]);

  useEffect(() => {
    if (!addSupervisorSignature) {
      props.handleClearImage("signature2");
      setSignature2Image(false);
      props.values.signature2Dto.signatureFile2 = null;
      props.setIsSignatureFile2Deleted(true);
      props.values.signature2Dto.isSignatureImageDeleted = 1;
    }
  }, [addSupervisorSignature]);

  // let modalityList = [];
  // props.modalityList?.map((modality) => {
  //   modalityList.push({
  //     key: modality.id,
  //     text: modality.name,
  //   });
  // });

  const addTimeToReportOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddTimeToReport = useCallback((e, option) => {
    props.values.addTimeToReport = option.key === "true" ? true : false;
  });

  const addDateToReportOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddDateToReport = useCallback((e, option) => {
    props.values.addDateToReport = option.key === "true" ? true : false;
  });

  const historyAvailableOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setHistoryAvailable = useCallback((e, option) => {
    props.values.historyAvailable = option.key === "true" ? true : false;
  });

  const activeStatusOptions = [
    {
      key: "true",
      text: "Active",
    },
    {
      key: "false",
      text: "Inactive",
    },
  ];

  const setActive = useCallback((e, option) => {
    props.values.active = option.key === "true" ? true : false;
  });

  const enableShareReportLinkOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setEnableShareReportLinkValue = useCallback((e, option) => {
    props.values.enableShareReportLink = option.key === "true" ? true : false;
    setEnableShareReportLink(props.values.enableShareReportLink);
  });

  const addPrintDisclaimerOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAddPrintDisclaimerValue = useCallback((e, option) => {
    props.values.addPrintDisclaimer = option.key === "true" ? true : false;
    setEnablePrintDisclaimerText(props.values.addPrintDisclaimer);
  });

  const setAddendumDisclaimerEnabledValue = useCallback((e, option) => {
    props.values.addendumDisclaimerEnabled =
      option.key === "true" ? true : false;
    setEnableAddendumDisclaimerText(props.values.addendumDisclaimerEnabled);
  });

  const qcEnabledOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setQcEnabledValue = useCallback((e, option) => {
    props.values.qcEnabled = option.key === "true" ? true : false;
    setQcEnabled(props.values.qcEnabled);
  });

  const twoSignaturesAllowedOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setTwoSignaturesAllowedValue = useCallback((e, option) => {
    props.values.twoSignaturesAllowed = option.key === "true" ? true : false;
  });

  const autoAssignEnableOptions = [
    {
      key: "true",
      text: "Yes",
    },
    {
      key: "false",
      text: "No",
    },
  ];

  const setAutoAssignEnableValue = useCallback((e, option) => {
    props.values.autoAssignEnable = option.key === "true" ? true : false;
    setAutoAssignEnabled(props.values.autoAssignEnable);
  });

  const allowedFileTypes = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];

  return (
    <>
      {(props.action === ACTIONS.ADD ||
        props.action === ACTIONS.EDIT ||
        props.editConfigurationSetting) && (
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.settings")}
            </p>
          </section>

          {((props.action === ACTIONS.ADD &&
            props.roles[0] === USERTYPES.ADMIN) ||
            (props.action === ACTIONS.EDIT &&
              ((props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm) ||
                (props.roles[0] === USERTYPES.ADMIN &&
                  props.values.isMinimalAccount === 0)))) && (
            <>
              <div style={{ display: "flex", maxHeight: "60px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.study-link-validity-time")}
                  </p>
                </div>
                <div
                  className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div style={{ marginLeft: "5px" }}>
                    <TextField
                      type="number"
                      name="studyLinkExpiryTime"
                      placeholder={t("hospital.study-link-validity-time")}
                      value={props.values.studyLinkExpiryTime}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      errorMessage={
                        (props.errorState?.studyLinkExpiryTime?.error &&
                          props.errorState?.studyLinkExpiryTime?.msg) ||
                        props.firmGlobalErrorState?.studyLinkExpiryTime
                      }
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  maxHeight: "40px",
                  marginTop: "-10px",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-share-report-link")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.enableShareReportLink}
                      onChangeCustom={() => {
                        setEnableShareReportLink(!enableShareReportLink);
                        props.values.enableShareReportLink =
                          !props.values.enableShareReportLink;
                      }}
                    />
                  </div>
                </div>
              </div>
              {enableShareReportLink && (
                <div style={{ display: "flex", maxHeight: "60px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.report-link-validity-time")}
                    </p>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: "5px" }}>
                      <TextField
                        type="number"
                        name="reportLinkExpiryTime"
                        placeholder={t("hospital.report-link-validity-time")}
                        value={props.values.reportLinkExpiryTime}
                        onBlur={props.handleBlur}
                        onChange={(e) => props.handleChange(e)}
                        errorMessage={
                          (props.errorState?.reportLinkExpiryTime?.error &&
                            props.errorState?.reportLinkExpiryTime?.msg) ||
                          props.firmGlobalErrorState?.reportLinkExpiryTime
                        }
                      />
                    </div>
                  </div>
                  {/* <div
                    className="ms-Grid-col ms-sm6 ms-lg2 ms-xl2 single-line-form-field-value"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span>(Hours only)</span>
                  </div> */}
                </div>
              )}
            </>
          )}

          {/* INCLUDE REPORTING DATE */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                {t("hospital.include-report-date")}
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.addDateToReport}
                  onChangeCustom={() => {
                    props.values.addDateToReport = props.values.addDateToReport
                      ? false
                      : true;
                  }}
                />
              </div>
            </div>
          </div>

          {/* INCLUDE REPORTING TIME */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                {t("hospital.include-report-time")}
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.addTimeToReport}
                  onChangeCustom={() => {
                    props.values.addTimeToReport =
                      !props.values.addTimeToReport;
                  }}
                />
              </div>
            </div>
          </div>

          {/* ENABLE SHOW PRIORS LINK IN REPORT */}
          {((props.roles[0] === USERTYPES.ADMIN &&
            props.action === ACTIONS.ADD) ||
            (props.roles[0] === USERTYPES.FIRMADMIN &&
              ((props.action === ACTIONS.EDIT && props.ownFirm) ||
                props.action === ACTIONS.ADD))) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.show-priors-studies")}
                    </p>
                  </div>
                  <div id="show-priors-studies-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.showPriorsStudies}
                        onChangeCustom={() => {
                          props.values.showPriorsStudies =
                            !props.values.showPriorsStudies;
                        }}
                      />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* INCLUDE SUPERVISOR SIGNATURE */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                Include Supervisor Signature
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                {/* <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.addSupervisorSignature}
                  onChangeCustom={() => {
                    setAddSupervisorSignature((prev) => !prev);
                    props.values.addSupervisorSignature =
                      !props.values.addSupervisorSignature;
                  }}
                /> */}
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={props.values.addSupervisorSignature}
                  onChangeCustom={() => {
                    const newValue = !props.values.addSupervisorSignature;
                    setAddSupervisorSignature(newValue);
                    props.values.addSupervisorSignature = newValue;
                  }}
                />
              </div>
            </div>
          </div>

          {/* SUPERVISOR SIGNATURES           */}
          {addSupervisorSignature && (
            <>
              <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Second Signature:</label>
                    <div>
                      {props.signature2ImageValue != null &&
                        props.signature2ImageValue != "" &&
                        signature2Image &&
                        props.values.signature2Dto.isSignatureImageDeleted ==
                          0 && (
                          <img
                            id=""
                            src={props.signature2ImageValue}
                            className="image-container-signature"
                          />
                        )}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="signatureFile2"
                        type="file"
                        name="signatureFile2"
                        onChange={(ev) => {
                          if (addSupervisorSignature) {
                            setSupervisor2Signature(ev.target.files[0].name);
                            props.values.signature2Dto.signatureFile2 =
                              ev.target.files[0];
                            props.setIsSignatureFile2Deleted(false);
                            props.values.signature2Dto.isSignatureImageDeleted = 0;
                            ev.target.value = null;
                          }
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      {!props.values.signature2Dto.isSignatureImageDeleted && (
                        <label
                          style={{ marginLeft: "10px" }}
                          for="signatureFile2"
                        >
                          {supervisor2Signtaure}
                        </label>
                      )}
                      {((props.signature2ImageValue != null &&
                        props.signature2ImageValue != "" &&
                        signature2Image) ||
                        (supervisor2Signtaure != null &&
                          supervisor2Signtaure != "")) &&
                        props.values.signature2Dto.isSignatureImageDeleted ==
                          0 && (
                          <PrimaryButton
                            text="Clear Second Signature"
                            className="study-list-clear-all-button"
                            style={{ marginLeft: "5px", marginTop: "5px" }}
                            onClick={() => {
                              props.handleClearImage("signature2");
                              setSignature2Image(false);
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Third Signature:</label>
                    <div>
                      {props.signature3ImageValue != "" &&
                        props.signature3ImageValue != null &&
                        signature3Image &&
                        props.values.signature3Dto.isSignatureImageDeleted ==
                          0 && (
                          <img
                            id=""
                            src={props.signature3ImageValue}
                            className="image-container-signature"
                          />
                        )}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="signatureFile3"
                        type="file"
                        name="signatureFile3"
                        onChange={(ev) => {
                          if (addSupervisorSignature) {
                            setSupervisor3Signature(ev.target.files[0].name);
                            props.values.signature3Dto.signatureFile3 =
                              ev.target.files[0];
                            props.setIsSignatureFile3Deleted(false);
                            props.values.signature3Dto.isSignatureImageDeleted = 0;
                            ev.target.value = null;
                          }
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      {!props.values.signature3Dto.isSignatureImageDeleted && (
                        <label
                          style={{ marginLeft: "10px" }}
                          for="signatureFile3"
                        >
                          {supervisor3Signtaure}
                        </label>
                      )}
                      {((props.signature3ImageValue != null &&
                        props.signature3ImageValue != "" &&
                        signature3Image) ||
                        (supervisor3Signtaure != null &&
                          supervisor3Signtaure != "")) &&
                        props.values.signature3Dto.isSignatureImageDeleted ==
                          0 && (
                          <PrimaryButton
                            text="Clear Third Signature"
                            className="study-list-clear-all-button"
                            style={{ marginLeft: "5px", marginTop: "5px" }}
                            onClick={() => {
                              props.handleClearImage("signature3");
                              setSignature3Image(false);
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>{t("hospital.second-signature-text")}:</label>

                    <TextField
                      className="other-textArea"
                      styles={{
                        root: {
                          width: "40%",
                        },
                      }}
                      name="signature2Dto.signatureText"
                      placeholder={t("hospital.second-signature-text")}
                      value={props.values.signature2Dto.signatureText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      errorMessage={
                        props.errorState?.signature2Dto.signature2Text.error &&
                        props.errorState?.signature2Dto.signature2Text.msg
                      }
                      resizable
                      multiline
                    />
                  </div>
                </div>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>{t("hospital.third-signature-text")}: </label>

                    <TextField
                      className="other-textArea"
                      styles={{
                        root: {
                          width: "40%",
                        },
                      }}
                      name="signature3Dto.signatureText"
                      placeholder={t("hospital.third-signature-text")}
                      value={props.values.signature3Dto.signatureText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      errorMessage={
                        props.errorState?.signature3Dto.signature3Text.error &&
                        props.errorState?.signature3Dto.signature3Text.msg
                      }
                      resizable
                      multiline
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE ADDENDUM DISCLAIMER */}
          {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
            <>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-addendum-disclaimer")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.addendumDisclaimerEnabled}
                      onChangeCustom={() => {
                        setEnableAddendumDisclaimerText(
                          !enableAddendumDisclaimerText
                        );
                        props.values.addendumDisclaimerEnabled =
                          !props.values.addendumDisclaimerEnabled;
                      }}
                    />
                  </div>
                </div>
              </div>
              {enableAddendumDisclaimerText && (
                <div style={{ display: "flex" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.addendum-disclaimer-text")}
                    </p>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "5px",
                    }}
                  >
                    <TextField
                      styles={{
                        root: {
                          width: "100%",
                        },
                      }}
                      name="addendumDisclaimerText"
                      placeholder={t("hospital.addendum-disclaimer-text")}
                      value={props.values.addendumDisclaimerText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      resizable
                      multiline
                      errorMessage={
                        props.errorState?.addendumDisclaimerText?.error &&
                        props.errorState?.addendumDisclaimerText?.msg
                      }
                    />
                  </div>
                </div>
              )}
            </>
          )}

          {/* ENABLE DOWNLOAD STUDY */}
          {props.roles[0] === USERTYPES.ADMIN && (
            <>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-download-study")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.allowDownloadStudy}
                      onChangeCustom={() => {
                        props.values.allowDownloadStudy =
                          !props.values.allowDownloadStudy;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE DOWNLOAD REPORT */}
          {props.roles[0] === USERTYPES.ADMIN && (
            <>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-download-report")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.allowDownloadReport}
                      onChangeCustom={() => {
                        props.values.allowDownloadReport =
                          !props.values.allowDownloadReport;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ENABLE QR CODE IN REPORT */}
          {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-qr-code")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableQRCodeInReport}
                        onChangeCustom={() => {
                          props.values.enableQRCodeInReport =
                            !props.values.enableQRCodeInReport;
                        }}
                      />
                    </div>
                  </div>
                </div>
                <span style={{ fontSize: "11px", paddingLeft: "5px" }}>
                  {t("hospital.qr-code-link-expity-msg")}
                </span>
              </div>
            </>
          )}

          {/* ENABLE STUDY SHARING LINK IN REPORT */}
          {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-study-sharing")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableStudySharingLinkInReport}
                        onChangeCustom={() => {
                          props.values.enableStudySharingLinkInReport =
                            !props.values.enableStudySharingLinkInReport;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}


          {/* ENABLE UNASSIGNMENT SERVICE  */}
          {(props.action === ACTIONS.EDIT &&
            props.roles[0] === USERTYPES.FIRMADMIN &&
            !props.ownFirm) ||
            (props.action === ACTIONS.ADD &&
              props.roles[0] === USERTYPES.FIRMADMIN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-unassignment-service")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableUnassignmentService}
                        onChangeCustom={() => {
                          props.values.enableUnassignmentService =
                            !props.values.enableUnassignmentService;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {(props.action === ACTIONS.EDIT &&
            props.roles[0] === USERTYPES.FIRMADMIN &&
            !props.ownFirm) ||
            (props.action === ACTIONS.ADD &&
              props.roles[0] === USERTYPES.FIRMADMIN && (
                <>
                  {/* AUTO ASSIGNMENT ENABLE */}
                  {/* <div style={{ display: "flex", maxHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-auto-assignment")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.autoAssignEnable}
                          onChangeCustom={() => {
                            setAutoAssignEnabled((prev) => !prev);
                            props.values.autoAssignEnable =
                              !props.values.autoAssignEnable;
                          }}
                        />
                      </div>
                    </div>
                  </div> */}

                  {/* {autoAssignEnabled && (
                    <div style={{ display: "flex", maxHeight: "60px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <p className="single-line-form-field-key">
                          {t("hospital.modality")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                        <div
                          style={{
                            paddingLeft: "8px",
                            marginTop: "5px",
                            display: "flex",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <ComboBox
                            selectedKey={selectedAutoAssignModality}
                            placeholder="Select Modality"
                            options={[
                              {
                                key: "selectAll",
                                text: "Select All",
                                itemType:
                                  SelectableOptionMenuItemType.SelectAll,
                              },
                              ...modalityList,
                            ]}
                            multiSelect
                            calloutProps={{ doNotLayer: true }}
                            onChange={(e, option) => {
                              const selected = option?.selected;
                              const currentSelectedOptionKeys =
                                selectedAutoAssignModality.filter(
                                  (key) => key !== "selectAll"
                                );
                              const selectAllState =
                                currentSelectedOptionKeys.length ===
                                modalityList.length;

                              if (option) {
                                if (option?.key === "selectAll") {
                                  selectAllState
                                    ? setSelectedAutoAssignModality([])
                                    : setSelectedAutoAssignModality([
                                        "selectAll",
                                        ...modalityList.map((o) => o.key),
                                      ]);
                                } else {
                                  const updatedKeys = selected
                                    ? [...currentSelectedOptionKeys, option.key]
                                    : currentSelectedOptionKeys.filter(
                                        (k) => k !== option.key
                                      );
                                  if (
                                    updatedKeys.length === modalityList.length
                                  ) {
                                    // updatedKeys.push('selectAll');
                                  }
                                  setSelectedAutoAssignModality(updatedKeys);
                                }
                              }
                            }}
                            errorMessage={
                              props.errorState?.autoAssignModalityIds?.error &&
                              props.errorState?.autoAssignModalityIds?.msg
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )} */}

                  {/* ENABLE PRINT DISCLAIMER */}
                  <div style={{ display: "flex", maxHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-print-disclaimer")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.addPrintDisclaimer}
                          onChangeCustom={() => {
                            setEnablePrintDisclaimerText(
                              !enablePrintDisclaimerText
                            );
                            props.values.addPrintDisclaimer =
                              !props.values.addPrintDisclaimer;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {enablePrintDisclaimerText && (
                    <div style={{ display: "flex" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <p className="single-line-form-field-key">
                          {t("hospital.print-disclaimer-text")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value">
                        <div
                          style={{
                            marginTop: "5px",
                            marginLeft: "5px",
                          }}
                        >
                          <TextField
                            styles={{
                              root: {
                                width: "100%",
                              },
                            }}
                            name="printDisclaimerText"
                            placeholder={t("hospital.print-disclaimer-text")}
                            value={props.values.printDisclaimerText}
                            onBlur={props.handleBlur}
                            onChange={(e) => props.handleChange(e)}
                            resizable
                            multiline
                            errorMessage={
                              props.errorState?.printDisclaimerText?.error &&
                              props.errorState?.printDisclaimerText?.msg
                            }
                          />
                        </div>
                      </div>
                    </div>
              )}
              

              {/* ENABLE MS WORD */}
          {/* {(props.action === ACTIONS.ADD && ((props.roles[0] === USERTYPES.ADMIN) || (props.roles[0] === USERTYPES.FIRMADMIN)))  && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-ms-word")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.showWord}
                        onChangeCustom={() => {
                          props.values.showWord =
                            !props.values.showWord;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )} */}

                  {/* ENTER ACCOUNT WARNING */}
                  <div style={{ display: "flex" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.account-warning")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <TextField
                          name="accountWarning"
                          placeholder={t("hospital.account-warning")}
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          value={props.values.accountWarning}
                          resizable
                          multiline
                          errorMessage={
                            props.errorState?.accountWarning?.error &&
                            props.errorState?.accountWarning?.msg
                          }
                          // disabled={!isOtherReason}
                        />
                      </div>
                    </div>
                  </div>

                  {/* QUALITY CHECK ENABLED */}
                  <div
                    style={{
                      display: "flex",
                      maxHeight: "40px",
                      marginTop: "5px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-quality-check")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.qcEnabled}
                          onChangeCustom={() => {
                            setQcEnabled((prev) => !prev);
                            props.values.qcEnabled = !props.values.qcEnabled;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))}
          {qcEnabled && (
            <>
              <div
                style={{ display: "flex", maxHeight: "40px", marginTop: "5px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.allow-two-signatures")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.twoSignaturesAllowed}
                      onChangeCustom={() => {
                        props.values.twoSignaturesAllowed =
                          !props.values.twoSignaturesAllowed;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", maxHeight: "60px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.modality")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                  <div
                    style={{
                      paddingLeft: "8px",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <ComboBox
                      selectedKey={selectedModality}
                      placeholder="Select Modality"
                      options={[...modalityList]}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          setSelectedModality((prevSelectedKeys) =>
                            selected
                              ? [...prevSelectedKeys, option.key]
                              : prevSelectedKeys.filter((k) => k !== option.key)
                          );
                        }
                      }}
                      errorMessage={
                        props.errorState?.modalityIds?.error &&
                        props.errorState?.modalityIds?.msg
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {props.roles[0] === USERTYPES.FIRMADMIN && (
              <>
                <div style={{ display: "flex", maxHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.sub_modality_list_number")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                      <Dropdown
                        selectedKey={props.values.selectedSubModalityListNumber}
                        placeholder="Select Sub Modality List Number"
                        options={[...subModalityListNumbers]}
                        calloutProps={{ doNotLayer: true }}
                        onChange={(e, option) => {
                          props.values.selectedSubModalityListNumber =
                            option.key;
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    maxHeight: "70px",
                    marginTop: "5px",
                  }}
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.branch-code")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                      <TextField
                        name="branchCode"
                        onChange={(e) => {
                          props.handleChange(e);
                        }}
                        errorMessage={props.firmGlobalErrorState?.branchCode}
                        value={props.values.branchCode}
                        onBlur={props.handleBlur}
                        resizable={false}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      )}
      {props.action === ACTIONS.VIEW && !props.editConfigurationSetting && (
        <div className="tab-section">
          <section className="sectionA" style={{ marginBottom: "1rem" }}>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.settings")}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">
            {/* STUDY LINK EXPIRY TIME */}
            {(props.ownFirm ||
              (props.roles[0] === USERTYPES.ADMIN &&
                props.values.isMinimalAccount === 0)) &&
              !props.values.isClientWarning && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.study-link-validity-time")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                    <div>
                      {props.values.studyLinkExpiryTime
                        ? props.values.studyLinkExpiryTime
                        : "0"}
                    </div>
                  </div>
                </div>
              )}

            {!props.editConfigurationSetting &&
              !props.values.isClientWarning &&
              props.roles[0] != USERTYPES.FIRMDOCTOR && (
                <>
                  {props.roles[0] != USERTYPES.FIRMTECHNICIAN &&
                    ((props.roles[0] === USERTYPES.ADMIN &&
                      props.values.isMinimalAccount === 0) ||
                      (props.roles[0] === USERTYPES.FIRMADMIN &&
                        props.ownFirm)) && (
                      <>
                        {" "}
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.enable-share-report-link")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div>
                              {props.values.enableShareReportLink
                                ? "Yes"
                                : "No"}
                            </div>
                          </div>
                        </div>
                        {!!enableShareReportLink && (
                          <div
                            className="ms-Grid-row"
                            style={{ minHeight: "40px" }}
                          >
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                              <div className="form-heading">
                                {t("hospital.report-link-validity-time")}
                              </div>
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                              <div>
                                {props.values.reportLinkExpiryTime
                                  ? props.values.reportLinkExpiryTime
                                  : "0"}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  <div
                    className="ms-Grid-row"
                    style={{ display: "flex", minHeight: "40px" }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className=" form-heading">
                        {t("hospital.include-report-date")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 ">
                      <div>{props.values.addTimeToReport ? "Yes" : "No"}</div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.include-report-time")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div>{props.values.addDateToReport ? "Yes" : "No"}</div>
                    </div>
                  </div>
                  {props.roles[0] === USERTYPES.FIRMADMIN &&
                    props.action === ACTIONS.VIEW &&
                    props.ownFirm && (
                      <div
                        className="ms-Grid-row"
                        style={{ minHeight: "40px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                          <div className="form-heading">
                            {t("hospital.show-priors-studies")}
                          </div>
                        </div>
                        <div id="show-priors-studies-value" className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            {props.values.showPriorsStudies ? "Yes" : "No"}
                        </div>
                      </div>
                    )}
                  {props.roles[0] != USERTYPES.FIRMTECHNICIAN && (
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.active")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div>{props.values.active ? "Active" : "Inactive"}</div>
                      </div>
                    </div>
                  )}
                </>
              )}

            {/* SUPERVISOR SIGNATURE */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm)) && (
              <>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      Include Supervisor Signature
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div>
                      {props.values.addSupervisorSignature ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                {props.values.addSupervisorSignature && (
                  <>
                    <div
                      style={{ display: "flex", width: "95%", padding: "2.5%" }}
                    >
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>Second Signature:</label>
                          <div>
                            {props.signature2ImageValue != "" ? (
                              <img
                                id=""
                                src={props.signature2ImageValue}
                                className="image-container-signature"
                                alt="Signature not available"
                              />
                            ) : (
                              <div>{t("hospital.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>Third Signature:</label>
                          <div>
                            {props.signature3ImageValue != "" ? (
                              <img
                                id=""
                                src={props.signature3ImageValue}
                                alt="Signature not available"
                                className="image-container-signature"
                              />
                            ) : (
                              <div>{t("hospital.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{ display: "flex", width: "95%", padding: "2.5%" }}
                    >
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{t("hospital.second-signature-text")}:</label>
                          <span>
                            {props.values.signature2Dto.signatureText}
                          </span>
                        </div>
                      </div>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{t("hospital.third-signature-text")}: </label>
                          <span>
                            {props.values.signature3Dto.signatureText}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {/* ADDENDUM DISCLAIMER */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMDOCTOR ||
              props.roles[0] === USERTYPES.FIRMTECHNICIAN ||
              (props.ownFirm && props.roles[0] === USERTYPES.FIRMADMIN)) && (
              <>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.enable-addendum-disclaimer")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {props.values.addendumDisclaimerEnabled ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                {!!enableAddendumDisclaimerText && (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.addendum-disclaimer-text")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                      <div>
                        {props.values.addendumDisclaimerText
                          ? props.values.addendumDisclaimerText
                          : ""}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* ENABLE DOWNLOAD STUDY */}
            {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-download-study")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.allowDownloadStudy ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* ENABLE DOWNLOAD REPORT */}
            {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-download-report")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.allowDownloadReport ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* ENABLE QR CODE REPORT */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-qr-code")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.enableQRCodeInReport ? "Yes" : "No"}</div>
                </div>
              </div>
            )}

            {/* ENABLE STUDY SHARING LINK IN REPORT */}
            {(props.roles[0] === USERTYPES.ADMIN ||
              props.roles[0] === USERTYPES.FIRMTECHNICIAN) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-study-sharing")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.enableStudySharingLinkInReport ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            )}


             {/* ENABLE UNASSIGNMENT SERVICE 
            {(props.roles[0] === USERTYPES.FIRMADMIN) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-unassignment-service")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.enableUnassignmentService ? "Yes" : "No"}</div>
                </div>
              </div>
            )}*/}


            {/* ENABLE MS WORD */}
            {/* {!props.ownFirm && (props.roles[0] === USERTYPES.ADMIN || (props.roles[0] === USERTYPES.FIRMADMIN)) && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-ms-word")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.showWord ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}

            {/* ACCOUNT WARNING */}
            {!props.ownFirm &&
              (props.roles[0] === USERTYPES.FIRMADMIN ||
                props.roles[0] === USERTYPES.SUPERVISOR) && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.account-warning")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                    <div>
                      {props.values.accountWarning
                        ? props.values.accountWarning
                        : "-"}
                    </div>
                  </div>
                </div>
              )}

            {!props.ownFirm && props.roles[0] === USERTYPES.FIRMADMIN && (
              <>
                {!enterprise && !props.values.isClientWarning && (
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.history-available")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{props.values.historyAvailable ? "Yes" : "No"}</div>
                    </div>
                  </div>
                )}
                {(props.roles[0] === USERTYPES.FIRMADMIN ||
                  props.roles[0] === USERTYPES.SUPERVISOR) && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-print-disclaimer")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>
                          {props.values.addPrintDisclaimer ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                    {!!enablePrintDisclaimerText && (
                      <div
                        className="ms-Grid-row"
                        style={{ minHeight: "40px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                          <div className="form-heading">Print Disclaimer</div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                          <div>
                            {props.values.printDisclaimerText
                              ? props.values.printDisclaimerText
                              : "0"}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {!enterprise && !props.values.isClientWarning && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-quality-check")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>{props.values.qcEnabled ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    {!!qcEnabled && (
                      <>
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.allow-two-signatures")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>
                              {props.values.twoSignaturesAllowed ? "Yes" : "No"}
                            </div>
                          </div>
                        </div>
                        {/* add modality ids part */}
                        <div
                          className="ms-Grid-row"
                          style={{ minHeight: "40px" }}
                        >
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <div className="form-heading">
                              {t("hospital.modality")}
                            </div>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                            <div>{props.values.modalityIds}</div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                        <div className="form-heading">
                          {t("hospital.enable-auto-assignment")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                        <div>
                          {props.values.autoAssignEnable ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                    {!!autoAssignEnabled && (
                      <div
                        className="ms-Grid-row"
                        style={{ minHeight: "40px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                          <div className="form-heading">
                            {t("hospital.modality")}
                          </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                          <div>{props.values.autoAssignModalityIds}</div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {props.roles[0] === USERTYPES.FIRMADMIN && (
                <>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.sub_modality_list_number")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div>
                        {props.values.selectedSubModalityListNumber
                          ? props.values.selectedSubModalityListNumber
                          : "-"}
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.branch-code")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>
                        {props.values.branchCode
                          ? props.values.branchCode
                          : "-"}
                      </div>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
      )}
    </>
  );
};

export default HospitalSettings;
